module.exports = __webpack_public_path__ + "static/media/p.9cd23400.svg";